var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"md-layout md-gutter md-alignment-center-center component-alignment"})
}
var staticRenderFns = []

export { render, staticRenderFns }